var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelry = function SvgJewelry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.001,
    height: 64
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10157",
    transform: "translate(-691 -626.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ebebeb",
    "data-name": "Ellipse 760",
    transform: "translate(691 626.335)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4629",
    transform: "translate(736.438 671.771)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.282,
    cy: 9.282,
    r: 9.282,
    fill: "#ffc62d",
    "data-name": "Ellipse 686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.729 3.276h13.1v13.1h-13.1Z",
    "data-name": "Path 4503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.103 8.19h-2.184V4.914H7.643V8.19H5.459l3.822 3.824ZM8.735 9.282V6.006h1.092v3.276h.639l-1.185 1.185-1.185-1.185Zm-3.276 3.822h7.644v1.092H5.459Z",
    "data-name": "Path 4504"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00243e",
    strokeWidth: 2,
    "data-name": "Group 1747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m730.767 646.668 5.553 6.8-12.977 16.533-13.664-16.35 5.49-6.988Z",
    "data-name": "Path 3658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.679 653.656h26.641",
    "data-name": "Line 1684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m715.169 646.668 3.646 6.988",
    "data-name": "Line 1685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.767 646.668-3.801 6.988",
    "data-name": "Line 1686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m722.999 646.668 3.967 6.988",
    "data-name": "Line 1687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.815 653.656 4.184-6.988",
    "data-name": "Line 1688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m723.342 670.002 3.623-16.346",
    "data-name": "Line 1689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.815 653.656 4.527 16.346",
    "data-name": "Line 1690"
  })))));
};
export { SvgJewelry as ReactComponent };
export default "/_next/static/images/jewelry.svg";